export default __webpack_public_path__ + "static/media/EM1350.34I-36495_-21470_0.bf82cbf2.jpg";